import React, { useEffect, useState } from "react";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";

const initialForm = {
  question: "",
  answer: "",
  category: "Commande",
};

const categories = [
  "Entretien",
  "Commande",
  "Tailles",
  "Matériaux",
  "Livraison",
  "Personnalisation",
  "Fabrication",
  "Atelier",
];

const AdminFaq = () => {
  const [faqs, setFaqs] = useState([]);
  const [form, setForm] = useState(initialForm);
  const [editingId, setEditingId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    fetchFaqs();
  }, []);

  const fetchFaqs = async () => {
    try {
      const res = await axios.get(`${apiUrl}/api/faq`);
      setFaqs(res.data);
    } catch (err) {
      console.error("Erreur chargement FAQs:", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      if (editingId) {
        await axios.put(`${apiUrl}/api/faq/${editingId}`, form);
      } else {
        await axios.post(`${apiUrl}/api/faq`, form);
      }
      setForm(initialForm);
      setEditingId(null);
      await fetchFaqs();
    } catch (err) {
      console.error("Erreur lors de l'envoi :", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEdit = (faq) => {
    setForm({
      question: faq.question,
      answer: faq.answer,
      category: faq.category,
    });
    setEditingId(faq._id);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer cette FAQ ?")) return;
    try {
      await axios.delete(`${apiUrl}/api/faq/${id}`);
      fetchFaqs();
    } catch (err) {
      console.error("Erreur suppression FAQ:", err);
    }
  };

  return (
    <div className="admin-faq-container">
      <style>
        {`
          :root {
            --primary: #4f46e5;
            --primary-light: #6366f1;
            --secondary: #10b981;
            --danger: #ef4444;
            --light: #f9fafb;
            --dark: #1f2937;
            --gray: #6b7280;
            --light-gray: #e5e7eb;
          }
          
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }
          
          .admin-faq-container {
            max-width: 1000px;
            margin: 0 auto;
            padding: 2rem;
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
            color: var(--dark);
          }
          
          .title {
            text-align: center;
            font-size: 2.25rem;
            font-weight: 800;
            margin-bottom: 2rem;
            background: linear-gradient(90deg, var(--primary), var(--primary-light));
            -webkit-background-clip: text;
            background-clip: text;
            color: transparent;
            position: relative;
          }
          
          .title:after {
            content: '';
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
            width: 80px;
            height: 4px;
            background: linear-gradient(90deg, var(--primary), var(--primary-light));
            border-radius: 2px;
          }
          
          .faq-form {
            background: white;
            padding: 2rem;
            border-radius: 16px;
            margin-bottom: 3rem;
            box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 10px 10px -5px rgba(0, 0, 0, 0.02);
            border: 1px solid rgba(0, 0, 0, 0.05);
            animation: fadeIn 0.4s ease-out;
          }
          
          .form-header {
            font-size: 1.25rem;
            font-weight: 600;
            margin-bottom: 1.5rem;
            color: var(--primary);
            display: flex;
            align-items: center;
            gap: 0.75rem;
          }
          
          .form-header svg {
            width: 1.5rem;
            height: 1.5rem;
          }
          
          .form-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 1.5rem;
            margin-bottom: 1.5rem;
          }
          
          .form-group {
            margin-bottom: 1.25rem;
          }
          
          label {
            display: block;
            margin-bottom: 0.5rem;
            font-weight: 500;
            color: var(--dark);
            font-size: 0.875rem;
          }
          
          input, textarea, select {
            width: 95%;
            padding: 0.75rem 1rem;
            border-radius: 8px;
            border: 1px solid var(--light-gray);
            font-size: 0.9375rem;
            transition: all 0.2s;
            background-color: var(--light);
          }
          
          input:focus, textarea:focus, select:focus {
            outline: none;
            border-color: var(--primary-light);
            box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
          }
          
          textarea {
            min-height: 120px;
            resize: vertical;
          }
          
          .button-group {
            display: flex;
            justify-content: flex-end;
            gap: 0.75rem;
            margin-top: 1.5rem;
          }
          
          .btn {
            padding: 0.75rem 1.5rem;
            border-radius: 8px;
            font-weight: 600;
            font-size: 0.9375rem;
            cursor: pointer;
            transition: all 0.2s;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 0.5rem;
            border: none;
          }
          
          .btn-primary {
            background: linear-gradient(90deg, var(--primary), var(--primary-light));
            color: white;
            box-shadow: 0 4px 6px -1px rgba(79, 70, 229, 0.2), 0 2px 4px -1px rgba(79, 70, 229, 0.1);
          }
          
          .btn-primary:hover {
            transform: translateY(-1px);
            box-shadow: 0 10px 15px -3px rgba(79, 70, 229, 0.2), 0 4px 6px -2px rgba(79, 70, 229, 0.1);
          }
          
          .btn-secondary {
            background-color: white;
            color: var(--gray);
            border: 1px solid var(--light-gray);
          }
          
          .btn-secondary:hover {
            background-color: var(--light);
          }
          
          .btn-success {
            background-color: var(--secondary);
            color: white;
          }
          
          .btn-danger {
            background-color: var(--danger);
            color: white;
          }
          
          .btn-sm {
            padding: 0.5rem 1rem;
            font-size: 0.875rem;
          }
          
          .faq-list {
            display: flex;
            flex-direction: column;
            gap: 1rem;
          }
          
          .empty-state {
            text-align: center;
            padding: 3rem 2rem;
            background-color: white;
            border-radius: 16px;
            box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05);
            animation: fadeIn 0.4s ease-out;
          }
          
          .empty-state svg {
            width: 4rem;
            height: 4rem;
            margin-bottom: 1rem;
            color: var(--light-gray);
          }
          
          .empty-state h3 {
            font-size: 1.25rem;
            font-weight: 600;
            margin-bottom: 0.5rem;
            color: var(--dark);
          }
          
          .empty-state p {
            color: var(--gray);
            max-width: 400px;
            margin: 0 auto;
          }
          
          .faq-card {
            background: white;
            border-radius: 12px;
            padding: 1.5rem;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02);
            border: 1px solid rgba(0, 0, 0, 0.05);
            transition: all 0.2s;
            animation: fadeIn 0.4s ease-out;
          }
          
          .faq-card:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.05), 0 4px 6px -2px rgba(0, 0, 0, 0.02);
          }
          
          .faq-content {
            flex: 1;
            margin-right: 1.5rem;
          }
          
          .faq-card h4 {
            font-size: 1.125rem;
            font-weight: 600;
            margin-bottom: 0.75rem;
            color: var(--dark);
          }
          
          .faq-card p {
            color: var(--gray);
            margin-bottom: 1rem;
            line-height: 1.5;
          }
          
          .category {
            font-size: 0.75rem;
            font-weight: 600;
            background-color: #e0e7ff;
            color: var(--primary);
            padding: 0.25rem 0.75rem;
            border-radius: 9999px;
            display: inline-block;
          }
          
          .action-buttons {
            display: flex;
            gap: 0.5rem;
          }
          
          .loading-spinner {
            width: 1rem;
            height: 1rem;
            border: 2px solid rgba(255, 255, 255, 0.3);
            border-radius: 50%;
            border-top-color: white;
            animation: spin 1s ease-in-out infinite;
          }
          
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
          
          @media (max-width: 768px) {
            .form-grid {
              grid-template-columns: 1fr;
            }
            
            .faq-card {
              flex-direction: column;
            }
            
            .faq-content {
              margin-right: 0;
              margin-bottom: 1.5rem;
            }
            
            .action-buttons {
              align-self: flex-end;
            }
          }
        `}
      </style>

      <h2 className="title">Panneau d'administration FAQ</h2>

      <form onSubmit={handleSubmit} className="faq-form">
        <div className="form-header">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
          {editingId
            ? "Modifier une question"
            : "Ajouter une nouvelle question"}
        </div>

        <div className="form-grid">
          <div className="form-group">
            <label>Question</label>
            <input
              type="text"
              value={form.question}
              onChange={(e) => setForm({ ...form, question: e.target.value })}
              required
              placeholder="Quelle est la question ?"
            />
          </div>

          <div className="form-group">
            <label>Catégorie</label>
            <select
              value={form.category}
              onChange={(e) => setForm({ ...form, category: e.target.value })}
            >
              {categories.map((cat) => (
                <option key={cat} value={cat}>
                  {cat}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="form-group">
          <label>Réponse</label>
          <textarea
            value={form.answer}
            onChange={(e) => setForm({ ...form, answer: e.target.value })}
            required
            placeholder="Rédigez la réponse complète..."
          />
        </div>

        <div className="button-group">
          {editingId && (
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => {
                setForm(initialForm);
                setEditingId(null);
              }}
            >
              Annuler
            </button>
          )}

          <button
            type="submit"
            className="btn btn-primary"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                <span className="loading-spinner"></span>
                En cours...
              </>
            ) : editingId ? (
              "Mettre à jour"
            ) : (
              "Ajouter la question"
            )}
          </button>
        </div>
      </form>

      <div className="faq-list">
        {faqs.length === 0 ? (
          <div className="empty-state">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <h3>Aucune question disponible</h3>
            <p>Commencez par ajouter votre première question à la FAQ</p>
          </div>
        ) : (
          faqs.map((faq) => (
            <div className="faq-card" key={faq._id}>
              <div className="faq-content">
                <h4>{faq.question}</h4>
                <p>{faq.answer}</p>
                <span className="category">{faq.category}</span>
              </div>

              <div className="action-buttons">
                <button
                  className="btn btn-success btn-sm"
                  onClick={() => handleEdit(faq)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                  Modifier
                </button>

                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDelete(faq._id)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  </svg>
                  Supprimer
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AdminFaq;
